// @ts-nocheck — vendor fullscreen APIs on Document / HTMLElement.
import React, { useCallback, useState } from "react";
import {
  UncontrolledDropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu
} from "reactstrap";
import injectIntl from "Util/injectIntl";
import { useDispatch } from "react-redux";
import { useAppSelector } from "Redux/hooks";
import { changeLocale } from "Redux/actions";
import { localeOptions } from "Constants/defaultValues";

function Fullscreen() {
  const locale = useAppSelector(s => s.settings.locale);
  const dispatch = useDispatch();
  const [isInFullScreen, setIsInFullScreen] = useState(false);

  const handleChangeLocale = useCallback(
    l => {
      dispatch(changeLocale(l));
    },
    [dispatch]
  );

  const checkFullScreen = useCallback(() => {
    return (
      (document.fullscreenElement && document.fullscreenElement !== null) ||
      (document.webkitFullscreenElement &&
        document.webkitFullscreenElement !== null) ||
      (document.mozFullScreenElement &&
        document.mozFullScreenElement !== null) ||
      (document.msFullscreenElement && document.msFullscreenElement !== null)
    );
  }, []);

  const toggleFullScreen = useCallback(() => {
    const full = checkFullScreen();
    const docElm = document.documentElement;
    if (!full) {
      if (docElm.requestFullscreen) {
        docElm.requestFullscreen();
      } else if (docElm.mozRequestFullScreen) {
        docElm.mozRequestFullScreen();
      } else if (docElm.webkitRequestFullScreen) {
        docElm.webkitRequestFullScreen();
      } else if (docElm.msRequestFullscreen) {
        docElm.msRequestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    }
    setIsInFullScreen(!full);
  }, [checkFullScreen]);

  return (
    <div>
      <div className="d-flex">
        <UncontrolledDropdown className="ml-2">
          <DropdownToggle
            caret
            color="light"
            size="sm"
            className="language-button"
          >
            <span className="name">{locale.toUpperCase()}</span>
          </DropdownToggle>
          <DropdownMenu className="mt-3" right>
            {localeOptions.map(l => (
              <DropdownItem
                onClick={() => handleChangeLocale(l.id)}
                key={l.id}
              >
                {l.name}
              </DropdownItem>
            ))}
          </DropdownMenu>
        </UncontrolledDropdown>
        <button
          className="mx-3 header-icon btn btn-empty d-none d-sm-inline-block"
          type="button"
          id="fullScreenButton"
          onClick={toggleFullScreen}
        >
          {isInFullScreen ? (
            <i className="simple-icon-size-actual d-block" />
          ) : (
            <i className="simple-icon-size-fullscreen d-block" />
          )}
        </button>
      </div>
    </div>
  );
}

export default injectIntl(Fullscreen);
